import React, { useState, useEffect, useContext } from 'react';
import HelpSiteService from "../SuperAdmin/Controller/Configuration/HelpSiteController";
import { ThemeContext } from "../Layout/Theme/ThemeContext";

const HelpSite = ({ webLink }) => {

    const [link, setLink] = useState(webLink);
    const { theme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";



    // Function to open the help page in a new window
    const openHelpWindow = () => {
        if (link) {
            const width = window.screen.width * 0.5;
            const height = window.screen.height * 0.5;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;

            window.open(
                link.startsWith('http') ? link : `http://${link}`,
                'HelpWindow',
                `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
            );
        }
    };

    return (
        <>
            {link ? (
                <a href="#" onClick={openHelpWindow} class="email-link">
                    <img src="assets/img/resources/weblink.png" alt="Add icon" style={{ "height": "22px" }} />
                </a>
            ) : (
                ""
            )}
        </>
    );
};

export default HelpSite;
